import { render, staticRenderFns } from "./DialogBadWord.vue?vue&type=template&id=6bdece41"
import script from "./DialogBadWord.vue?vue&type=script&lang=js"
export * from "./DialogBadWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports